import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Modal } from 'antd';
import IconButton from 'components/IconButton';
import clsx from 'clsx';
import styles from './style.module.less';
const TutorialModal = ({ skipTutorial, tutorialAction, children, tutorialActionLabel, visible, className, skipTutorialLabel, }) => {
    return (_jsxs(Modal, { open: visible, footer: false, destroyOnClose: true, closable: false, className: clsx(styles.tutorialModal, className), children: [children, _jsxs("div", { className: styles.controls, children: [_jsx(Button, { type: "primary", onClick: tutorialAction, className: styles.primaryButton, children: tutorialActionLabel }), _jsx(IconButton, { onClick: skipTutorial, children: skipTutorialLabel })] })] }));
};
export default TutorialModal;
